import { Application } from "@hotwired/stimulus"
import { Datepicker } from "stimulus-datepicker"
import { dom, config } from '@fortawesome/fontawesome-svg-core';

const application = Application.start()
application.register("datepicker", Datepicker)

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

export { application }

// FontAwesome configuration and Turbo integration
document.addEventListener('turbo:load', function() {
  config.mutateApproach = 'sync';
  dom.watch();
});
